import api from '@edu-fe/api'

export default {
  name: 'exchange',

  getList: api.create(`/vip/my/exchange`),

  push: (code) => api.create(`/vip/exchange?code=${code}`)
}
